import React from "react";
import PropTypes from "prop-types";

import styles from "./NewsletterHeader.css";

export default function NewsletterHeader(props) {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className={styles.root}>
      <span>{props.headerText}</span>
    </div>
  );
}

NewsletterHeader.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  headerText: PropTypes.string,
};

NewsletterHeader.defaultProps = {
  isVisible: true,
  headerText: "",
};
